import { render, staticRenderFns } from "./AccountDetailsSkeleton.vue?vue&type=template&id=ee2f509c&scoped=true"
import script from "./AccountDetailsSkeleton.vue?vue&type=script&lang=js"
export * from "./AccountDetailsSkeleton.vue?vue&type=script&lang=js"
import style0 from "./AccountDetailsSkeleton.vue?vue&type=style&index=0&id=ee2f509c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee2f509c",
  null
  
)

export default component.exports